import React, { useEffect, useState } from "react";
import { Scale, ShieldCheck } from "lucide-react";

const STORAGE_KEY = "pg_disclaimer_accepted_v1";

export default function DisclaimerModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) {
      // small delay for smoother UX
      const t = setTimeout(() => setOpen(true), 400);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  const decline = () => {
    // Redirect away from the site
    window.location.href = "https://www.google.com";
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      aria-modal="true"
      role="dialog"
    >
      <div className="absolute inset-0 bg-[#0a1428]/85 backdrop-blur-sm" />
      <div className="relative bg-white w-full max-w-3xl max-h-[92vh] overflow-hidden rounded-sm shadow-2xl border-t-4 border-[#c9a961] flex flex-col">
        <div className="bg-[#0e1b34] text-white px-8 py-6 flex items-center gap-4">
          <div className="w-12 h-12 rounded-sm bg-[#c9a961]/15 border border-[#c9a961]/40 flex items-center justify-center flex-shrink-0">
            <ShieldCheck className="text-[#c9a961]" size={22} />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#c9a961] font-semibold">
              Bar Council of India Notice
            </div>
            <h2 className="font-serif-display text-2xl md:text-3xl mt-1">Disclaimer</h2>
          </div>
        </div>

        <div className="px-8 py-6 overflow-y-auto text-sm leading-relaxed text-neutral-700 space-y-3">
          <p>
            As per the rules of the <span className="font-semibold text-[#0e1b34]">Bar Council of India</span>, an advocate is not permitted to solicit work or advertise. By proceeding further and clicking on <span className="font-semibold">&ldquo;I Agree&rdquo;</span> below, the user acknowledges that:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              There has been no advertisement, personal communication, solicitation, invitation or inducement of any sort whatsoever from <span className="font-semibold">Pravin Gupta &amp; Associates</span> or any of its members to solicit any work through this website.
            </li>
            <li>
              The user wishes to gain more information about the firm for his / her own information and use.
            </li>
            <li>
              The information about the firm is provided to the user only on his / her specific request, and any information obtained or material downloaded from this website is completely at the user&rsquo;s volition. Any transmission, receipt or use of this website is not intended to, and will not, create any lawyer-client relationship.
            </li>
            <li>
              The information provided on this website should not be construed as legal advice. The firm is not liable for any consequence of any action taken by the user relying on material / information provided under this website. In cases where the user has any legal issues, he / she must in all cases seek independent legal advice from a qualified advocate.
            </li>
            <li>
              The contents of this website are the intellectual property of Pravin Gupta &amp; Associates.
            </li>
          </ul>
          <p className="pt-2 text-neutral-600">
            By clicking &ldquo;I Agree&rdquo;, the user acknowledges having read and understood this disclaimer beyond all reasonable doubts, freely and without coercion, and unconditionally intends to proceed to the website.
          </p>
        </div>

        <div className="px-8 py-5 border-t border-neutral-200 bg-[#f7f2e8]/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-xs text-neutral-500">
            <Scale size={14} className="text-[#b28e42]" />
            <span>Pravin Gupta &amp; Associates &middot; Advocates &amp; Solicitors</span>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={decline} className="btn-outline-gold">
              Decline
            </button>
            <button onClick={accept} className="btn-gold">
              I Agree
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
